import styled from 'styled-components/macro';
import search_icon from 'assets/icons/search.svg';
import chevron from 'assets/icons/chevron.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: #1f2939;
  height: 38px;
  box-shadow: none;
  border-radius: 0 8px 8px 0;
  border: none;
  border-left: 1px solid #ced5de;
`;

export const SearchIcon = styled.img.attrs({ src: search_icon })`
  padding: 8px 0 8px 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  outline: none;
  border: none;
  width: calc(100% - 56px);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #1f2939;
  padding: 8px 16px 8px 8px;

  ::placeholder {
    color: #697180;
    line-height: 20px;
  }
`;

export const ChevronIcon = styled.img.attrs({
  src: chevron,
})<{ isOpen: boolean }>`
  box-sizing: content-box !important;
  padding: ${(props) => (props.isOpen ? '8px 0 8px 8px' : '8px 8px 8px 0')};
  rotate: ${(props) => (props.isOpen ? '180deg' : '0')};
  height: 16px;
  width: 16px;
  cursor: pointer;
`;
